'use strict'
import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../../views/webSite/HomePage.vue'
import Home from '../../views/webApp/Home.vue'
import Dashboard from '../../views/webApp/Dashboard'
import Atendimentos from '../../views/webApp/Atendimento/Atendimentos.vue'
import AtendimentosTable from '../../views/webApp/Atendimento/AtendimentosTable.vue'
import Atendimento from '../../views/webApp/Atendimento/Atendimento.vue'
import Pedidos from '../../views/webApp/Pedidos/Pedidos.vue'
import Pedido from '../../views/webApp/Pedidos/Pedido.vue'
import PedidosTable from '../../views/webApp/Pedidos/PedidosTable.vue'
import Projeto from '../../views/webApp/Projeto/Projeto.vue'
import CRMVendas from '../../views/webApp/CRMVendas'
import Administrativo from '../../views/webApp/Administrativo'
import Aviso from '../../views/webApp/Administrativo/Aviso'
import Ajustes from '../../views/webApp/Ajustes'
import Empresa from '../../views/webApp/Ajustes/Empresa.vue'
import Acessos_permissoes from '../../views/webApp/Ajustes/Acessos_permissoes.vue'
import MinhaConta from '../../views/webApp/MinhaConta/MinhaConta.vue'
import Cadastros from '../../views/webApp/Administrativo/Cadastros/Cadastros.vue'
import CadastroClientes from '../../views/webApp/Administrativo/Cadastros/Clientes.vue'
import CadastroProdutos from '../../views/webApp/Administrativo/Cadastros/Produtos.vue'
import CadastroAtendimentos from '../../views/webApp/Administrativo/Cadastros/atendimentos/'
import AtendimentosSituacoes from '../../views/webApp/Administrativo/Cadastros/atendimentos/Situacoes.vue'
import CadastroUsuarios from '../../views/webApp/Administrativo/Cadastros/Usuarios.vue'
import CadastroIdiomas from '../../views/webApp/Administrativo/Cadastros/Idiomas.vue'
import CadastroSetores from '../../views/webApp/Administrativo/Cadastros/Setores.vue'
import RedefinirSenha from '../../views/webApp/Administrativo/Cadastros/RedefinirSenha.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'HomePage',
        component: HomePage
    },
    {
        path: '/recuperarSenha/:id?/:token?',
        name: 'RedefinirSenha',
        component: RedefinirSenha
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
        children: [
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: Dashboard
            },
            {
                path: '/atendimentos',
                name: 'Atendimentos',
                component: Atendimentos,
                children: [
                    {
                        path: '/atendimentos/:id/:tab',
                        name: 'AtendimentosTable',
                        component: AtendimentosTable,
                    }
                ]
            },
            {
                path: '/atendimento',
                name: 'Atendimento',
                component: {
                    render(h) {
                        return h(Atendimento, {
                            key: `${this.$route.query.id}${this.$route.query.callType}`
                        })
                    }
                }
            },
            {
                path: '/pedidos',
                name: 'Pedidos',
                component: Pedidos,
                children: [
                    {
                        path: '/pedidos/:code?',
                        name: 'PedidosTable',
                        component: PedidosTable,
                    }
                ]
            },
            {
                path: '/pedido/:id?',
                name: 'Pedido',
                component: {
                    render(h) {
                        return h(Pedido, {
                            key: this.$route.params.id
                        })
                    }
                }
            },
            {
                path: '/pedido/novoPedido',
                name: 'Pedido',
                component: Pedido,
                props: true
            },
            {
                path: '/projeto',
                name: 'Projeto',
                component: Projeto
            },
            {
                path: '/CRMVendas',
                name: 'CRMVendas',
                component: CRMVendas
            },
            {
                path: '/administrativo',
                name: 'Administrativo',
                component: Administrativo,
                children: [
                    {
                        path: '/cadastros',
                        name: 'Cadastros',
                        component: Cadastros,
                        children: [
                            {
                                path: '/clientes',
                                name: 'CadastroClientes',
                                component: CadastroClientes
                            },
                            {
                                path: '/produtos',
                                name: 'CadastroProdutos',
                                component: CadastroProdutos
                            },
                            {
                                path: '/usuarios',
                                name: 'CadastroUsuarios',
                                component: CadastroUsuarios
                            },
                            {
                                path: '/cadastro_atendimentos',
                                name: 'CadastroAtendimentos',
                                component: CadastroAtendimentos,
                                children: [
                                    {
                                        path: '/atendimentos_situacoes',
                                        name: 'AtendimentosSituacoes',
                                        component: AtendimentosSituacoes
                                    }
                                ]
                            },
                            {
                                path: '/idiomas',
                                name: 'CadastroIdiomas',
                                component: CadastroIdiomas
                            },
                            {
                                path: '/setores',
                                name: 'CadastroSetores',
                                component: CadastroSetores
                            },
                        ],
                    },
                    {
                        path: '/aviso',
                        name: 'Aviso',
                        component: Aviso
                    }
                ]
            },
            {
                path: '/ajustes',
                name: 'Ajustes',
                component: Ajustes,
                children: [
                    {
                        path: '/empresa',
                        name: 'Empresa',
                        component: Empresa
                    },
                    {
                        path: '/acessos_permissoes',
                        name: 'Acessos_permissoes',
                        component: Acessos_permissoes
                    },
                ]
            },
            {
                path: '/minhaconta',
                name: 'MinhaConta',
                component: MinhaConta
            }
        ]
    },
]

const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

const publicPaths = ['/', '/recuperarSenha']

router.beforeEach((to, from, next) => {
    const isPublic = publicPaths.some(path => to.path === path || to.path.startsWith(path + '/'))
    let hasSession = false
    try {
        hasSession = !!JSON.parse(localStorage.getItem('user') || '{}').TOKEN
    } catch (e) { hasSession = false }
    if (!isPublic && !hasSession) {
        localStorage.setItem('goTo', to.fullPath)
        return next('/')
    }
    next()
})

export default router
